"use client";
import { Button } from "@/components/ui/button";
import { UI } from "@/constants";

type ErrorProps = {
  error: Error;
  reset: () => void;
};

const Error = ({ error, reset }: ErrorProps) => {
  return (
    <main className="main-container py-24 gap-4 flex flex-col items-center">
      <h1 className="text-xl font-semibold text-red-600">{UI.errors.somethingWentWrong}</h1>
      <p className="capitalize">{error?.message || UI.errors.unknownError}</p>
      <Button onClick={() => reset()}>{UI.buttons.tryAgain}</Button>
    </main>
  );
};
export default Error;
